var chunkToChildrenMap = {
	"354": [
		267,
		678,
		620
	],
	"685": [
		500,
		741,
		43
	],
	"706": [
		747,
		716,
		222,
		271
	],
	"831": [
		424,
		373,
		152,
		812,
		163,
		732,
		706,
		25,
		286,
		311,
		928,
		450,
		224,
		47,
		771,
		772,
		354,
		685
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));